export default __webpack_public_path__ + "static/banner-img-1-4ee55dbdb611986236c56b666c18c11a.png";